import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericListUICDTO, GenericListUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { UICMasterType } from 'src/app/Common/UICServices/uic.enum';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { SalesReleaseDetailDTO, SalesReleaseSearchByReleaseNoRequestDTO } from 'src/app/sale/sales-release/sales-release-detail/sales-release-detail.interface';
import { SalesReleaseDetailService } from 'src/app/sale/sales-release/sales-release-detail/sales-release-detail.service';
import { SalesReleaseDTO } from 'src/app/sale/sales-release/sales-release.interface';
import { SalesReleaseService } from 'src/app/sale/sales-release/sales-release.service';



@Component({
  selector: 'app-add-via-sales-release-reference-button',
  templateUrl: './add-via-sales-release-reference-button.component.html',
  styleUrls: ['./add-via-sales-release-reference-button.component.css']
})
export class AddViaSalesReleaseReferenceButtonComponent implements OnInit {
  changeAllPrices(event: any) {
    this.SelectedReleaseItems.forEach(i => i.price = Number(event.target.value))
  }

  ngOnInit(): void {
    this.SalesReleaseNo.valueChanges.subscribe(res => {
      console.log(res);
      if (res) {
        this.GetItemsBySalesReleaseId(Number(res))
      }
    })

    this.GetTableUI()
  }

  @Input() EnablePriceEdit: boolean = false
  @Input({ required: true }) MasterId: number = 0
  @Input({ required: true }) MasterType: string = ''
  @Output() onSubmit: EventEmitter<SalesReleaseDetailDTO[]> = new EventEmitter<SalesReleaseDetailDTO[]>();
  gListUICService = inject(GenericListUicService);
  ReleaseItems: SalesReleaseDetailDTO[] = [];
  SelectedReleaseItems: SalesReleaseDetailDTO[] = [];
  salesReleaseService = inject(SalesReleaseService)
  salesReleaseDetailService = inject(SalesReleaseDetailService)
  User = inject(UserLoginService).User()
  SalesReleaseList: SalesReleaseDTO[] = [];
  prdListUIC: GenericListUICDTO[] = []
  dataLoading: boolean = false
  submitResults() {
    this.isSubmitting = true
    this.SelectedReleaseItems.forEach(item => {
      item.qtyType = item.qtyType ?? '';
      item.remarks = item.remarks ?? '';
      item.displaySeq = item.displaySeq ?? 0;

      item.otherDetail1 = item.otherDetail1 ?? '';
      item.otherDetail2 = item.otherDetail2 ?? '';
      item.otherDetail3 = item.otherDetail3 ?? '';
      item.otherDetail4 = item.otherDetail4 ?? '';
      item.otherDetail5 = item.otherDetail5 ?? '';
      item.otherDetail6 = item.otherDetail6 ?? '';
    });
    this.onSubmit.emit(this.SelectedReleaseItems)

  }

  SalesReleaseNo = new FormControl('')

  title = 'Sales Release'
  ReleaseModalRef!: NgbModalRef
  isSubmitting: boolean = false
  @ViewChild('ReleaseItemModal', { static: true }) ReleaseModalTemplate!: ElementRef

  modalService = inject(NgbModal)
  searchLoading: boolean = false;

  openModal() {
    this.SalesReleaseNo.reset()
    this.SelectedReleaseItems = []
    this.ReleaseItems = []
    this.SalesReleaseList = []
    this.searchLoading = true;
    let data: SalesReleaseSearchByReleaseNoRequestDTO = {
      releaseNo: '',
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }
    this.salesReleaseService.SalesRelease_SearchByReleaseNo(data).subscribe(res => {
      this.SalesReleaseList = res.items
      this.searchLoading = false;

    })
    this.ReleaseModalRef = this.modalService.open(this.ReleaseModalTemplate, { size: 'lg' })
  }

  SearchSalesRelease(event: { term: string; items: any[]; }) {
    console.log(event.term);
    setTimeout(() => {
      this.searchLoading = true;
      let data: SalesReleaseSearchByReleaseNoRequestDTO = {
        releaseNo: event.term,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      }
      this.salesReleaseService.SalesRelease_SearchByReleaseNo(data).subscribe(res => {
        this.SalesReleaseList = res.items
        this.searchLoading = false;

      })
    }, 500);

  }


  GetItemsBySalesReleaseId(releaseId: number) {
    this.dataLoading = true
    // Switching release: drop ticks from the previous one so they aren't imported with this one
    this.SelectedReleaseItems = []
    this.salesReleaseDetailService.SalesReleaseDetail_ReadByReleaseIdForImport({
      releaseId, masterId: this.MasterId, masterType: this.MasterType,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    }).subscribe(res => {
      this.ReleaseItems = res.items
      this.dataLoading = false

    })
  }

  GetTableUI() {
    let data: GenericListUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.SalesReleaseDetailList,
      tenantId: this.User.companyId
    }

    this.gListUICService.GenericListUIC_ReadByTenantId(data).subscribe(res => {
      this.prdListUIC = res.items
    })
  }


  handleItemSelection(event: { checkstate: boolean; data: SalesReleaseDetailDTO; }) {
    event.data.isSelected = event.checkstate
  }


  onSelctionCheckboxChange(event: any, item: SalesReleaseDetailDTO) {
    item.isSelected = event.target.checked
    let isDuplicate = this.SelectedReleaseItems.find(i => i.itemId == item.itemId)

    if (event.target.checked) {
      if (!isDuplicate)
        this.SelectedReleaseItems.push(item)
    } else {
      this.SelectedReleaseItems = this.SelectedReleaseItems.filter(i => i.itemId != item.itemId)
    }

    console.log(this.SelectedReleaseItems);
  }

  isAllChecked() {
    return this.ReleaseItems?.length > 0 &&
      this.ReleaseItems.every(i => i.isSelected);
  }

  toggleAll(event: any) {
    const checked = event.target.checked;

    this.ReleaseItems.forEach(item => {
      item.isSelected = checked;
    });

    if (checked) {
      this.SelectedReleaseItems = [...this.ReleaseItems];
    } else {
      this.SelectedReleaseItems = [];
    }

    console.log(this.SelectedReleaseItems);
  }



}
